import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
import en from '../translations/en.json'
import es from '../translations/es.json'
import pt from '../translations/pt.json'

const resources = {
  en: { translation: en },
  es: { translation: es },
  pt: { translation: pt }
}

function getTenantSlugForI18n(): string {
  const envSlug = import.meta.env.VITE_TENANT_SLUG
  if (envSlug) return envSlug

  const hostname = window.location.hostname
  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    /^\d+\.\d+\.\d+\.\d+$/.test(hostname)
  ) {
    return 'kin-riman'
  }

  const parts = hostname.split('.')
  if (parts.length >= 3) {
    return parts[0]
  }

  return hostname
}

function getDefaultLanguage(): string {
  const slug = getTenantSlugForI18n()
  if (slug === 'test-56') return 'pt'
  return 'es'
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: getDefaultLanguage(),
    lng: localStorage.getItem('i18nextLng') || getDefaultLanguage(),

    interpolation: {
      escapeValue: false // React already escapes
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  })

export default i18n
